import uris from '../utils/uris'
import axios from '../utils/axiosWrapper'

import {filter, findIndex, reduce, cloneDeep, assign} from 'lodash'

let supervisorDistributors = []

export default {
  getDistributorsPointer () {
    return supervisorDistributors
  },
  getRemoteFiles (options) {
    /*
    options: {
      onSuccess: ()
      onError: ()
    }
    */
    axios.get(uris.URL_SUPERVISOR_REMOTE_FILES)
      .then((response) => {
        // console.log('Se obtuvieron los archivos remotos')
        supervisorDistributors.splice(0)
        supervisorDistributors.push(...response.data.rows)

        if (options.onSuccess) {
          options.onSuccess(supervisorDistributors)
        }
      }, (err) => {
        console.warn('Error obteniendo los archivos remotos')
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  getOutDatedFtpFiles () {
    /*
      Esta desactualizado si:
      - isOutDate = true o undefined
    */
    return filter(supervisorDistributors, (s) => (s.isOutdated === undefined || s.isOutdated === true) && s.fromNow !== 'a day ago').length
  },
  getUpdatedFtpFiles () {
    return filter(supervisorDistributors, (s) => s.isOutdated === false || s.fromNow === 'a day ago').length
  },
  getConsistencyCorrectLogs () {
    return filter(supervisorDistributors, (s) => {
      try {
        return (
          s.lastLog.length > 0 &&
          s.canReadJsonLog &&
          !s.isLastLogOutdated &&
          reduce(s.lastLog, (total, min) => {
            if (min.fileName) { // Si encuentra ese campo
              return total && (
                min.linesNotMatchingColumns.length === 0 &&
                min.linesWithColumnsIssues.length === 0 &&
                min.linesWithNotMatchingType.length === 0
              ) && (min.totalLinesInput - min.totalLinesOutput === 0)
            } else if (min.error) {
              return min.error.match(/^File \w+?\.txt not found in file config\.mdlz\.json\.$/)
            } else {
              return false
            }
          }, true) === true
        )
      } catch (error) {
        return (
          s.lastLog.length > 0 &&
          s.canReadJsonLog &&
          !s.isLastLogOutdated &&
          reduce(s.lastLog, (total, min) => {
            return total && min.errors.length === 0 && min.rowsRemove === 0
          }, true) === true
        )
      }
    }).length
  },
  getDatabaseCorrectLogs () {
    return filter(supervisorDistributors, (s) => {
      return (
        (!s.isSalesMaxDateOutdated && !s.isSalesLastUpdatedOutdated) ||
        (s.salesMaxDateFromNow === 'a day ago' || s.salesLastUpdateFromNow === 'a day ago')
      )
    }).length
  },
  getNonInconsistencyCorrectData () {
    return filter(supervisorDistributors, (s) => s.inconsistenciesCounter === 0).length
  },
  getSupervisorFtpFiles () {
    return supervisorDistributors
  },
  updateSupervisorFtpFile (options) {
    /*
    options: {
      data: {
        item: {}
      }
    }
    */
    // PARSEAR AQUI Y EN REMOVE?
    axios.post(uris.URL_SUPERVISOR_REMOTE_UPDATE_FILE, {
      distributorID: options.data.item.distributorID !== 0 ? String(options.data.item.distributorID) : '',
      newRemoteFileName: options.data.item.remoteFileName
    })
      .then((response) => {
        let index = findIndex(supervisorDistributors, (file) => {
          return file.distributorID === options.data.item.distributorID
        })
        Object.assign(supervisorDistributors[index], options.data.item)
        if (options.onSuccess) {
          options.onSuccess(supervisorDistributors)
        }
      }, (err) => {
        console.warn('Error actualizando archivo remoto')
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  removeSupervisorFtpFile (options) {
    /*
    options: {
      data: {
        item: {}
      }
    }
    */
    axios.post(uris.URL_SUPERVISOR_REMOTE_REMOVE_FILE, {
      distributorID: options.data.item.distributorID !== 0 ? String(options.data.item.distributorID) : ''
    })
      .then((response) => {
        // let index = supervisorFtpFiles.indexOf(options.data.item)
        let index = findIndex(supervisorDistributors, (file) => {
          return file.distributorID === options.data.item.distributorID
        })
        supervisorDistributors[index].remoteFileName = ''
        if (options.onSuccess) {
          options.onSuccess(supervisorDistributors)
        }
      }, (err) => {
        console.warn('Error eliminando archivo remoto')
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  addDistributor (options) {
    /* let distributor = {
      distributorID: 0,
      remoteFileName: options.data.item.remoteFileName,
      distributorName: options.data.item.distributorName,
      distributorCode1: options.data.item.distributorCode1,
      distributorCode2: options.data.item.distributorCode2,
      distributorCode3: options.data.item.distributorCode3
    } */
    let distributor = options.data.item
    axios.post(uris.URL_SUPERVISOR_REMOTE_ADD_DISTRIBUTOR, {
      distributorID: distributor.distributorID,
      remoteFileName: distributor.remoteFileName,
      distributorName: distributor.distributorName,
      distributorCode1: distributor.distributorCode1,
      distributorCode2: distributor.distributorCode2,
      distributorCode3: distributor.distributorCode3,
      contactMail: distributor.contactMail,
      inconsistenciesFileUrl: distributor.inconsistenciesFileUrl
    })
      .then((response) => {
        distributor.distributorID = response.data.distributorID
        supervisorDistributors.push(distributor)
        if (options.onSuccess) {
          options.onSuccess(supervisorDistributors)
        }
        if (options.finally) options.finally()
      }, (err) => {
        console.warn('Error agregando distribuidora')
        if (options.onError) {
          options.onError(err)
        }
        if (options.finally) options.finally()
      })
  },
  editDistributor (options) {
    axios.post(uris.URL_SUPERVISOR_REMOTE_EDIT_DISTRIBUTOR, assign(cloneDeep(options.data.item), {distributorID: String(options.data.item.distributorID)}))
      .then((response) => {
        let index = findIndex(supervisorDistributors, (distributor) => {
          return distributor.distributorID === options.data.item.distributorID
        })
        Object.assign(supervisorDistributors[index], options.data.item)
        if (options.onSuccess) {
          options.onSuccess(supervisorDistributors)
        }
        if (options.finally) options.finally()
      }, (err) => {
        console.warn('Error actualizando distribuidora')
        if (options.onError) {
          options.onError(err)
        }
        if (options.finally) options.finally()
      })
  },
  removeDistributor (options) {
    axios.post(uris.URL_SUPERVISOR_REMOTE_REMOVE_DISTRIBUTOR, assign(cloneDeep(options.data.item), {distributorID: String(options.data.item.distributorID)}))
      .then((response) => {
        let index = findIndex(supervisorDistributors, (distributor) => {
          return distributor.distributorID === options.data.item.distributorID
        })
        supervisorDistributors.splice(index, 1)
        if (options.onSuccess) {
          options.onSuccess(supervisorDistributors)
        }
      }, (err) => {
        console.warn('Error eliminando distribuidora')
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  sendInconsistenciesMail (options) {
    axios.post(uris.URL_SUPERVISOR_REMOTE_SEND_INCONSISTENCIES_MAIL, {
      distributorCode2: options.data.distributorCode2
    })
      .then((response) => {
        if (options.onSuccess) {
          options.onSuccess()
        }
      })
      .catch((err) => {
        console.warn('Error enviando correo')
        if (options.onError) {
          options.onError(err)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/storage/supervisorStorage.js